var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{attrs:{"value":_vm.value},on:{"change":_vm.onInput}},[_c('v-radio',{attrs:{"value":"html","label":"HTML"}}),_c('v-radio',{attrs:{"value":"txt","label":"テキスト"}}),_c('v-radio',{attrs:{"value":"json","label":"JSON"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }